import xhrService from "./xhrService";

import { controlMeasureApi, pollutantApi } from "./api/legendItem";
import findingsApi from "./api/finding";
import commentablesApi from "./api/commentable";
import { projectAssetsApi } from "./api/projectAsset";

export default xhrService;

/**
 * Asset source models for the map editor: the project's (non-archived) assets
 * scoped to the selected inspection's template.
 */
const assetTypeApi = {
  index: (projectId, inspectionId) =>
    projectAssetsApi
      .index(projectId, inspectionId)
      .then(assets => assets.filter(asset => !asset.archived_at)),
};

/**
 * the available APIs for each positionableType
 *
 * @important This object enables getting an api, dynamically
 */
export const positionableDataApis = {
  findingsApi,
  commentablesApi,
  controlMeasureApi,
  pollutantApi,
  assetTypeApi,
};
